import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { login, logout, me, type LoginInput } from "@/shared/api/session";

export const sessionQueryKey = ["session"];

export function useSession() {
  return useQuery({
    queryKey: sessionQueryKey,
    queryFn: me,
    retry: false,
  });
}

export function useLogin() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: LoginInput) => login(payload),
    onSuccess: (user) => {
      queryClient.clear();
      queryClient.setQueryData(sessionQueryKey, user);
    },
  });
}

export function useLogout() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.clear();
    },
  });
}
